import Analytics from "electron-google-analytics4"
import { isEmpty, isNil, isPlainObject } from "lodash"
import { get as getPersistValue } from "utils/persist_store"
import config from "../../config"
import { safeJSONParse } from "utils/json"

declare global {
  interface Window {
    dataLayer: object[]
  }
}

interface IPushDataLayer {
  event: string
  keyword?: string
  promotion_id?: string | number
  promotion_name?: string
  promotion_category?: string
  event_id?: string | number
  event_name?: string
  search_category_name?: string
  selected_result_name?: string
  promotion_location_name?: string
  event_location_name?: string
  dining_category_id?: string
  dining_category_name?: string
  dining_section_correlation_id?: string
  dining_section_name?: string
  origin_category?: string
  origin_feature_type?: string
  origin_id?: string
  origin_name?: string
  origin_local_categories?: string
  destination_category?: string
  destination_feature_type?: string
  destination_id?: string
  destination_local_categories?: string
  destination_name?: string
  avoid_steps?: boolean
  amenity_category?: string
  feature_id?: string | number
  feature_type?: string
  feature_name?: string
  feature_category?: string
  local_categories?: string
  directory_category_id?: string
  directory_category_name?: string
  directory_subcategory_name?: string
  directory_section_correlation_id?: string
  directory_section_name?: string
  post_id?: string | number
  post_type?: string
  post_category?: string
  post_title?: string
  post_location_name?: string
  post_location_url?: string
  service_id?: string | number
  service_title?: string
  search_mode?: string
  previous_parking_name?: string

  // Sponsor Content
  sponsor_content_id?: string | number
  sponsor_content_name?: string
  sponsor_content_media_mime?: string
  sponsor_content_media_src?: string
  sponsor_content_media_duration?: number
  sponsor_content_placement_type?: string
  sponsor_content_placement_width?: number
  sponsor_content_placement_height?: number

  app_language?: string
}

export type PushDataLayer = (
  data: IPushDataLayer,
  meta?: Record<string, any>
) => void

const trackingId = config("googleAnalyticsTrackingId")
const secretKey = config("googleAnalyticsSecretKey")
const appType = config("appType")
const analytics = new Analytics(trackingId, secretKey)

const setDeviceLocation = (data) => {
  const deviceLocation = getPersistValue("venue_device_location")
  if (deviceLocation) data["device_location"] = deviceLocation
}

const setLocationName = (data) => {
  data["location_name"] = getPersistValue("venue_device_name") || ""
}

const setMetaData = (data, meta) => {
  if (isNil(meta) || isEmpty(meta) || !isPlainObject(meta)) return
  for (const key in meta) {
    const value = meta[key]
    if (isNil(value)) continue
    data[key] = value
  }
}

const setAppLanguage = (data) => {
  data["app_language"] = getPersistValue("i18nextLng")
}

export const pushDataLayer: PushDataLayer = (data, meta = {}) => {
  if (appType === "electron") {
    const { event, ...eventParameters } = data
    analytics.setParams(eventParameters).event(event)
    return
  }
  // GTM prepares data in localStorage (if available) and attaches it to the event payload
  const metaFromLocalStorage = safeJSONParse(getPersistValue("GTM_META")) || {}
  setMetaData(data, metaFromLocalStorage)
  setMetaData(data, meta)
  setLocationName(data)
  setDeviceLocation(data)
  setAppLanguage(data)
  window.dataLayer.push(data)
}
